import React, { FC, useCallback } from 'react';
import { Button, Col, FormGroup, Input, Label, ModalBody, ModalFooter, Row } from 'reactstrap';
import { ValueCriterionOptions } from '../../../../../shared/orders/raffle';
import { Breadcrumb } from '../../../../components';
import { MaterialIconText } from '../../../../components/MaterialIconText';
import { useTranslation } from '../../../../translations';
import { emptyFallback, useNumericInputState } from '../../../../utils';
import { RaffleConfiguratorProps } from '../utils';

export const StaticValue: FC<RaffleConfiguratorProps<ValueCriterionOptions>> = ({
  defaultOptions,
  displayName,
  onBack,
  onCancel,
  onConfigure,
}) => {
  const { ts } = useTranslation();
  const [value, setValue] = useNumericInputState(defaultOptions?.value ?? 1);
  const onFinish = useCallback(() => {
    onConfigure({ name: 'value', options: { value } });
  }, [onConfigure, value]);

  return (
    <>
      <ModalBody>
        <Row>
          <Col xs={12}>
            <Breadcrumb
              items={[
                { text: `${ts('common.display_name')}: ${emptyFallback(displayName, 'None')}` },
                { text: `${ts('type')}: Static Value` },
              ]}
            />
            <MaterialIconText name="keyboard_backspace" onClick={onBack}>
              {ts('common.go_back')}
            </MaterialIconText>
            <hr />
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="value">{ts('common.value')}</Label>
              <Input
                id="value"
                name="value"
                onChange={setValue}
                required
                type="number"
                value={value}
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button className="editor-finish-btn" color="primary" disabled={!value} onClick={onFinish}>
          {ts('common.finish')}
        </Button>
        <Button className="editor-cancel-btn" color="secondary" onClick={onCancel} outline>
          {ts('common.cancel')}
        </Button>
      </ModalFooter>
    </>
  );
};
